// Derived tournament status — CLIENT MIRROR of deriveTournStatus() in
// functions/bvapi.js. Keep both in sync.
//
// tournStatus is a function of the current state, never of the action
// history:
//   Finished  — a winner exists
//   Running   — any elimination, or the clock has been started (running or
//               stopped at a non-zero position)
//   Seating   — no eliminations, clock stopped at 0, but a seat draw is in
//               effect (live.seated)
//   Scheduled — none of the above
// Incomplete / Merged / Split are explicit operator decisions and are never
// re-derived.
//
// The server derives it inside every transaction that touches eliminations
// or seating. The client owns the clock writes (start / stop / move), so it
// applies the same rule there.

const DERIVED_STATUSES = new Set(["Scheduled", "Seating", "Running", "Finished"]);

export function deriveTournStatus(t: any): string | null {
  if (!t) return null;
  const cur = t.tournStatus;
  if (cur && !DERIVED_STATUSES.has(cur)) return cur;
  const live = t.live || {};
  const params = t.params || {};
  let eliminated = 0;
  let winner = false;
  if (params.manageRegistrations) {
    const players = t.players || {};
    for (const uid in players) {
      const f = players[uid] && players[uid].finish;
      if (f === 1) winner = true;
      else if (f) eliminated++;
    }
  } else {
    // Counted mode: same final condition as countElimination.
    eliminated = live.out || 0;
    winner = eliminated > 0 && (params.actPlayers || 0) - eliminated <= 1;
  }
  if (winner) return "Finished";
  if (eliminated > 0 || live.running || (live.seconds || 0) > 0)
    return "Running";
  if (live.seated) return "Seating";
  return "Scheduled";
}
